import React from 'react'

function ThreePillarStrip() {
    const pillars = [
        {
            title: 'Precision Delivery',
            text: 'Every client gets a dedicated team, realistic timelines and direct access to leadership. Not a ticket queue. Not rotating agents who need to be re-briefed every call. The same people who learn your business from day one.',
            icon: 'fas fa-bullseye',
        },
        {
            title: 'Compliance First',
            text: 'Every process, every hire, every system is built around regulatory compliance from the beginning, not added on afterward. Because your data, your clients and your reputation all depend on getting this right.',
            icon: 'fas fa-shield-alt',
        },
        {
            title: 'Measurable Results',
            text: 'Denial rates cut by more than half. AR days reduced significantly. Security threats can be contained in under 15 minutes. We track what actually matters and put the numbers in front of you every single month.',
            icon: 'fas fa-chart-line',
        },
    ]
    return (
        <div className="three-pillar-strip td-section td-section--pillars rts-section-gap">
            <div className="container">
                <div className="td-section-head text-center mb-5">
                    <p className="td-section-label">Why TechDigit</p>
                    <h2 className="td-section-title">Three Pillar Strip</h2>
                    <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                </div>
                <div className="row g-4 g-lg-4 justify-content-center">
                    {pillars.map((pillar, i) => (
                        <div key={i} className="col-lg-4 col-md-12">
                            <div className="pillar-card">
                                <div className="pillar-card__header">
                                    <div className="pillar-icon" aria-hidden="true">
                                        <i className={pillar.icon} />
                                    </div>
                                    <div className="pillar-card__head-main">
                                        <div className="pillar-heading">
                                            <span className="pillar-number">{String(i + 1).padStart(2, '0')}</span>
                                            <h4 className="pillar-title">{pillar.title}</h4>
                                        </div>
                                    </div>
                                </div>
                                <p className="pillar-text">{pillar.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ThreePillarStrip
